import IndexManager from "../index-manager";
import debuggingProps from "./index.debug";
import { handlePreview } from "./index.preview";
import { debounce } from "lodash";

(async function() {

  /* ***************** */
  /*     Settings      */
  /* ***************** */
  const manager = new IndexManager('ts', {
    'ts_theme': 'default',
    'ts_font': 'default',
    'ts_customtitle': 'Leaderboard',
    'ts_customsubtitle': 'Top Supporter',
    'ts_interval': 7,
    'ts_count': 5,
    'ts_sortby': "unit",
    'ts_topthree': true,

    //colors default
    'ts_1_clr1': '#be1e2d',
    'ts_1_clr2': '#fed849',
    'ts_1_clr3': '#d7d8c8',
    'ts_1_clr4': '#f3ddca',
    'ts_1_clr5': '#fff',
    'ts_1_clr6': '#000',

    //colors retro
    'ts_2_clr1': '#fff',
    'ts_2_clr2': '#be1e2d',
    'ts_2_clr3': '#313131',
    'ts_2_clr4': '#a0a0a0',
    'ts_2_clr5': '#262522',

    //colors transitional
    'ts_3_clr1': '#ffffff',
    'ts_3_clr2': '#F0323C',
    'ts_3_clr3': '#ffffff',
    'ts_3_clr4': '#444444',
    'ts_3_clr5': '#444444',
    'ts_3_clr6': '#be1e2d',
    'ts_3_clr7': '#444444',

    //custom theme
    'ts_4_html': '',
    'ts_4_css': '',
    
    //ramadhan
    'ts_number_format': 'left',

  });

  /* ***************** */
  /*  Widget Behavior  */
  /* ***************** */
 
  class TrWidget {

    prevData = {};
    data = {};
    setting = {};
    theme = '';

    ts_interval() {
      return this.setting['ts_interval'] > 90 ? 90 : (this.setting['ts_interval'] < 1 ? 1 : this.setting['ts_interval']);
    }

    ts_count() {
      return this.setting['ts_count'] > 10 ? 10 : (this.setting['ts_count'] < 1 ? 1  : this.setting['ts_count']);
    }

    async setup(themeSetting, themeProps) {
      this.setting = themeSetting;
      this.theme = themeProps[this.setting['ts_theme']];
      this.theme.setup(this.setting);
      this.applyStyle();

      if(this.setting['ts_theme'] == 'custom') {
        await this.theme.setupCustomSetting(manager)
      }
    }

    /* Styling */

    applyStyle() {
      // Set Styles
      const styles = this.theme.styles();
      for (let i = 0; i < styles.length; i++) {
        const style = styles[i];
        h.setThemeVar(style.var, this.setting[style.key] || style.default);
      }
      // Set Fonts
      const reqFont = this.setting['ts_font'] || 'default';
      h.setThemeVar(
        this.theme.font().var,
        reqFont === 'default' ? this.theme.font().default : "'" + reqFont + "'"
      );
    }

    /* Handling Data */

    async reset(data) {
      this.prevData = h.cloneProp(this.data);
      this.data = h.cloneProp(data);
    }
    
    async updateData(data) {
      if (!this.theme) return;
      if (!this.setting) {
        console.debug('Applied setting not found');
        return;
      }
      if(data == null) return;
      if(Object.keys(data).length === 0) return;

      await this.reset(data);
      this.theme.render(data, this.prevData);
    }
  }

  /* ***************** */
  /*   Widget Manager  */
  /* ***************** */

  IndexManager.prototype.reloadHandler = debounce(() => {
    manager.loadData(true);
  }, 5000, { 'maxWait': 10000 });

  IndexManager.prototype.reload = async function(data) {
    this.widget.updateData(data);
  }

  /* ***************** */
  /*      API Call     */
  /* ***************** */

  IndexManager.prototype.loadData = async function(shouldForceRefresh = false) {
    let self = this;
    superagent
      .get(this.apiUrl(`stream/${this.key}/top-supporters`))
      .query({
        interval: this.widget.ts_interval(),
        count: this.widget.ts_count(),
        sortby: this.get('ts_sortby'),
        ...(shouldForceRefresh ? { force_refresh: true } : {}),
      })
      .accept('application/json')
      .end(async function (err, res) {
        try {
          let body = res.body
          let supporter = body.supporter
          supporter.forEach((item, index) => {
            if(!("uid" in item)) {
              supporter[index].uid =  generateRandomString()
            }
          });
          body.supporter = supporter

          // self.reload(res.body);
          self.reload(body);
        } catch (err) {
          // console.error(err.message);
          return null;
        }
      });

  }

  /* ***************** */
  /*     Websocket     */
  /* ***************** */

  function setupListener() {
    manager.addListenerOn('new-tip', function(data) {
      manager.reloadHandler()
    });
    manager.addListenerOn('new-tip-simulation', function(data) {
      manager.reloadHandler()
    });

    // Failover if webssockets has an issues
    if (!h.prop(manager, 'widget.setting.debug')) {
      setInterval(function() {
        manager.reloadHandler();
      }, 5 * 60 * 1000);
    }
  }

  /* ***************** */
  /*       Init        */
  /* ***************** */

  await manager.init({
    widget: new TrWidget(),
    debug: debuggingProps,
    preview: handlePreview
  })
  setupListener();

  /* Helper */ 
  function generateRandomString(length = 16) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

})();